// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/chunk." + chunkId + "." + "a7cbaf936e6a1c641eac" + ".js";
};